import { useState } from "react";
import { ButtonPropsType } from "./type.ts";
import LoaderComponent from "../loader/LoaderComponent.tsx";
import { categoryClass, sizeClass } from "./constants.ts";
import { twMerge } from "tailwind-merge";

const Button = ({
  className = "",
  children,
  type = "button",
  variant = "primary",
  icon = false,
  size = "base",
  tooltipContent = false,
  tooltip,
  loading,
  filled = true,
  onClick,
  ...props
}: ButtonPropsType) => {
  const [load, setLoad] = useState(loading ?? false);

  const handleClick = async (e) => {
    if (!onClick) return;
    setLoad(true);
    await onClick(e);
    setLoad(false);
  };

  return (
    <button
      data-tooltip-id={
        tooltip?.id ? tooltip.id : tooltipContent ? "common-tooltip" : undefined
      }
      data-tooltip-html={
        tooltip?.id
          ? tooltip.content
          : tooltipContent
            ? tooltipContent
            : undefined
      }
      className={twMerge(
        "group/button relative h-auto w-auto cursor-pointer rounded-lg shadow-sm shrink-0",
        "inline-flex items-center justify-center",
        "hover:bg-app-600 active:bg-app-800",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-app-500 focus-visible:ring-0",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "transition-all duration-200 ease-linear",
        sizeClass[size],
        categoryClass[variant],
        !filled ? "bg-transparent py-0" : "",
        className
      )}
      onClick={handleClick}
      {...props}
    >
      {load ? <LoaderComponent /> : !!icon ? icon : null}
      {children}
    </button>
  );
};

export default Button;
